<template>
<div>
    <div class="card-body">
        <b-row>
            <b-col xl="6">
                <div class="d-flex flex-wrap" style="gap: 10px;">
                    <b-input-group class="datatable-btn" style="width: 340px;">
                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                        <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                    </b-input-group>
                    <!-- <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #563EE0; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="toggleFilterShow()">
                        <feather type="filter"></feather>
                        <h7>Filter</h7>
                    </div>
                    <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="start_date || end_date || status || client || project || selectedDepartment || selectedDesignation || selectedEmployee">
                        <feather type="x"></feather>
                        <h7>Clear All</h7>
                    </div> -->
                </div>
            </b-col>
            <b-col xl="6">
                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>

        <!-- <div class="row mt-2" v-if="filterShow">
            <div class="col-md-12">
                <div class="grid-container mt-sm-0">
                    <div class="grid-item">
                        <datepicker placeholder="Start Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="start_date"></datepicker>
                    </div>
                    <div class="grid-item">
                        <datepicker placeholder="End Date" :typeable="true" input-class="datepicker-here form-control digits" v-model="end_date"></datepicker>
                    </div>
                    <div class="grid-item">
                        <b-form-select v-model="status" :options="formattedStatus"></b-form-select>
                    </div>
                    <div class="grid-item">
                        <b-form-select v-model="project" :options="formattedProjects"></b-form-select>
                    </div>
                    <div class="grid-item">
                        <b-form-select v-model="client" :options="formattedClients"></b-form-select>
                    </div>
                    <div class="grid-item">
                        <b-form-select v-model="selectedDepartment" :options="formattedDepartment"></b-form-select>
                    </div>
                    <div class="grid-item" v-if="selectedDepartment">
                        <b-form-select v-model="selectedDesignation" :options="formattedDesignation"></b-form-select>
                    </div>
                    <div class="grid-item" v-if="selectedDesignation">
                        <b-form-select v-model="selectedEmployee" :options="formattedEmployee"></b-form-select>
                    </div>
                </div>
            </div>
        </div> -->

        <div v-if="!loading && !error">
            <div class="table-responsive datatable-vue" style="margin-top: 22px;">
                <b-table show-empty stacked="md" :items="items" :fields="tablefields" :per-page="perPage" @filtered="onFiltered">
                    <template #cell(index)="data">
                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                    </template>

                    <template #cell(customer)="data">
                        {{ data.item?.client?.user_name || '-' }}
                    </template>

                    <template #cell(delivery_status)="data">
                        <span class="text-uppercase badge" :class="[
                            data.item?.challan?.delivery_status === 'partial' ? 'bg-warning' :
                            data.item?.challan?.delivery_status === 'completed' ? 'bg-success' :
                            'bg-secondary'
                        ]">
                            {{ data.item?.challan?.delivery_status || '-' }}
                        </span>
                    </template>

                    <template #cell(invoice_id)="data">
                        {{ data.item?.invoice?.invoice_id || '-' }}
                    </template>

                    <template #cell(order_id)="data">
                        {{ data.item?.order?.order_id || '-' }}
                    </template>

                    <template #cell(total_return_amount)="row">
                        <div style="display: flex; align-items: center;">
                            <span>{{ row.item?.total_return_amount || '-' }}</span>          
                            <div>
                                <div v-if="row.item.return_lines && row.item.return_lines.length">
                                    <feather :type="row.detailsShowing ? 'chevron-up' : 'chevron-down'" size="18" style="cursor: pointer; padding: 4px 16px;" @click="row.toggleDetails" />
                                </div>
                            </div>
                        </div>
                    </template>

                    <!-- 🔽 Row Details (Child Table) -->
                    <template #row-details="row">
                        <div class="p-3 bg-light border rounded">
                            <b-table small :items="row.item.return_lines" :fields="childFields" responsive>
                                <template #cell(index)="data">
                                    {{ data.index + 1 }}
                                </template>
                            </b-table>
                        </div>
                    </template>

                    <template #cell(return_status)="row">
                        <span
                            class="badge text-uppercase"
                            :class="getStatusClass(row.value)"
                            @click="getStatus(row.value, row.item.id)"
                            v-b-modal.modal-prevent-closing-status
                        >
                            {{ row.value }}
                        </span>
                    </template>

                    <template #cell(created_at)="data">
                        {{ new Date(data.item.created_at).toLocaleDateString() }}
                    </template>

                    <template #cell(action)="data">
                        <span style="display: flex; gap: 12px;">
                            <feather type="plus-square" size="21px" style="color: #F42A6B; cursor: pointer;" v-b-tooltip.hover title="Create Sales Return" @click="createSalesReturn(data.item)"></feather>
                        </span>
                    </template>
                </b-table>
            </div>
        </div>
        <div v-else>
            <div class="loader-box">
                <div class="loader-10"></div>
            </div>
        </div>
        <b-col md="6" class="my-1 p-0">
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
        </b-col>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this invoice?</div>
    </b-modal>

    <!-- Record Payment -->
    <b-modal id="modal-record" ref="modal" title="Record Payment" @show="resetModal" @hidden="resetModal" @ok="handleRecordOk">
        <form ref="form" @submit.stop.prevent="handleRecordSubmit">
            <b-form-group label="Amount" label-for="name-input" invalid-feedback="Item is required">
                <b-form-input id="name-input" v-model="record.paid_amount" placeholder="Enter Amount"></b-form-input>
            </b-form-group>
        </form>
    </b-modal>

    <!-- Update Status -->
    <b-modal id="modal-prevent-closing-status" ref="modal" title="Update Return Status" @ok="handleStatusOk">
        <form ref="form" @submit.stop.prevent="handleStatusSubmit">
            <b-form-group label="Status" label-for="name-input">
                <b-form-select v-model="selectedStatus" :options="formattedOptions"></b-form-select>
            </b-form-group>
        </form>
    </b-modal>
</div>
</template>

<script>
import { mapState } from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

export default {
    components: {
        Datepicker
    },

    props: {
        tabs: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'return_id',
                    label: 'Return ID'
                },
                {
                    key: 'customer',
                    label: 'Customer'
                },
                {
                    key: 'invoice_id',
                    label: 'Invoice'
                },
                {
                    key: 'order_id',
                    label: 'Order'
                },
                {
                    key: 'delivery_status',
                    label: 'Delivery Status'
                },
                {
                    key: 'return_status',
                    label: 'Return Status'
                },
                {
                    key: 'total_return_amount',
                    label: 'Return Amount'
                },
                {
                    key: 'created_at',
                    label: 'Created At'
                },
                // {
                //     key: 'action',
                //     label: 'Action'
                // }
            ],
            childFields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'product.name',
                    label: 'Product'
                },
                {
                    key: 'delivered_quantity',
                    label: 'Delivered Quantity'
                },
                {
                    key: 'return_quantity',
                    label: 'Return Quantity'
                },
                {
                    key: 'unit_price',
                    label: 'Unit Price'
                },
                {
                    key: 'return_amount',
                    label: 'Return Amount'
                }
            ],
            record: {
                paid_amount: '',
                invoice: '',
            },
            invoice_due: '',
            initialLoad: true,
            isModifyingDate: false,
            filterShow: false,
            filter: null,
            start_date: null,
            end_date: null,
            status: '',
            client: '',
            project: '',
            selectedDepartment: '',
            selectedDesignation: '',
            selectedEmployee: '',
            delete_value: null,
            selectedStatus: null,
            update_id: null,
            statuses: [
                {
                    id: 1,
                    name: 'Approved',
                    value: 'approved',
                },
                {
                    id: 2,
                    name: 'Rejected',
                    value: 'rejected',
                },
                {
                    id: 3,
                    name: 'Pending',
                    value: 'pending',
                }
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100]
        };
    },

    computed: {
        ...mapState({
            items: state => state.order.sales_return,
            count: state => state.order.sales_return_count,
            loading: state => state.order.submitLoading,
            error: state => state.order.submitError,
            department_list: state => state.department.departments,
            designation_list: state => state.department.designation_by_department,
            employee_list: state => state.department.employee_by_designation,
            projects: state => state.project.project,
            clients: state => state.client.client_without_pg
        }),

        formattedProjects() {
            return [{
                    value: '',
                    text: 'Select a project',
                    disabled: true
                },
                ...this.projects.map(status => ({
                    value: status.id,
                    text: status.title
                }))
            ];
        },

        formattedStatus() {
            return [{
                    value: '',
                    text: 'Select a status',
                    disabled: true
                },
                ...this.statusOptions.map(status => ({
                    value: status.value,
                    text: status.text
                }))
            ];
        },

        formattedClients() {
            return [{
                    value: '',
                    text: 'Select a client',
                    disabled: true
                },
                ...this.clients.map(client => ({
                    value: client.user.id,
                    text: client.company_name
                }))
            ];
        },

        formattedEmployee() {
            return [{
                    value: '',
                    text: 'Select a Employee',
                    disabled: true
                },
                ...this.employee_list.map(emp => ({
                    value: emp.id,
                    text: emp.full_name
                }))
            ];
        },

        formattedDesignation() {
            return [{
                    value: '',
                    text: 'Select Designation',
                    disabled: true
                },
                ...this.designation_list.map(desg => ({
                    value: desg.id,
                    text: desg.title
                }))
            ];
        },

        formattedDepartment() {
            return [{
                    value: '',
                    text: 'Select Department',
                    disabled: true
                },
                ...this.department_list.map(dept => ({
                    value: dept.id,
                    text: dept.name
                }))
            ];
        },

        formattedOptions() {
            return [{
                    value: '',
                    text: 'Select Status',
                    disabled: true
                },
                ...this.statuses.map(status => ({
                    value: status.value,
                    text: status.name
                }))
            ];
        }
    },

    watch: {
        selectedDepartment(newVal, oldVal) {
            this.$store.dispatch("department/fetchDesignationByDepartment", newVal)
        },

        selectedDesignation(newVal, oldVal) {
            this.$store.dispatch("department/fetchEmployeeByDesignation", newVal)
        },

        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/sales/sales-return',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage,
                        tabs: this.tabs
                    }
                });
                this.currentPage = newCurrentPage
                this.$store.dispatch("order/fetchSalesReturn", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    client: this.client,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                this.$router.replace({
                    path: '/sales/sales-return',
                    query: {
                        page: this.currentPage,
                        perPage: newperPage,
                        tabs: this.tabs
                    }
                });
                this.perPage = newperPage
                this.$store.dispatch("order/fetchSalesReturn", {
                    perPage: newperPage,
                    currentPage: this.currentPage,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    client: this.client,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        start_date(newVal, oldVal) {
            if (!this.initialLoad) {
                if (!this.isModifyingDate) {
                    this.isModifyingDate = true;
                    if (this.start_date !== null) {
                        this.start_date = moment(String(this.start_date)).format("YYYY-MM-DD");
                        this.$store.dispatch("order/fetchSalesReturn", {
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            search_term: this.filter,
                            status: this.status,
                            client: this.client,
                            project: this.project,
                            employee: this.selectedEmployee
                        }).then(() => {
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false;
                        });
                    } else {
                        this.$store.dispatch("order/fetchSalesReturn", {
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            search_term: this.filter,
                            status: this.status,
                            client: this.client,
                            project: this.project,
                            employee: this.selectedEmployee
                        }).then(() => {
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false;
                        });
                    }
                }
            }
        },

        end_date(newVal, oldVal) {
            if (!this.initialLoad) {
                if (!this.isModifyingDate) {
                    this.isModifyingDate = true;
                    if (this.end_date !== null) {
                        this.end_date = moment(String(this.end_date)).format("YYYY-MM-DD");
                        this.$store.dispatch("order/fetchSalesReturn", {
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            search_term: this.filter,
                            status: this.status,
                            client: this.client,
                            project: this.project,
                            employee: this.selectedEmployee
                        }).then(() => {
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false;
                        });
                    } else {
                        this.$store.dispatch("order/fetchSalesReturn", {
                            perPage: this.perPage,
                            currentPage: 1,
                            start_date: this.start_date,
                            end_date: this.end_date,
                            search_term: this.filter,
                            status: this.status,
                            client: this.client,
                            project: this.project,
                            employee: this.selectedEmployee
                        }).then(() => {
                            this.totalRows = this.count;
                            this.initialLoad = false;
                            this.isModifyingDate = false;
                        });
                    }
                }
            }
        },

        filter(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("order/fetchSalesReturn", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    client: this.client,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        status(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("order/fetchSalesReturn", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    client: this.client,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        client(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("order/fetchSalesReturn", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    client: this.client,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        project(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("order/fetchSalesReturn", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    client: this.client,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        },

        selectedEmployee(newVal, oldVal) {
            if (!this.initialLoad) {
                this.$store.dispatch("order/fetchSalesReturn", {
                    perPage: this.perPage,
                    currentPage: 1,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    search_term: this.filter,
                    status: this.status,
                    client: this.client,
                    project: this.project,
                    employee: this.selectedEmployee
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false;
                });
            }
        }
    },

    mounted() {
        this.$store.dispatch("client/fetchClient_without_pg")
        this.$store.dispatch("employee/fetchEmployeeList");
        this.$store.dispatch("department/fetchDepartments")
        this.$store.dispatch("project/fetchProject")

        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage,
                        tabs: this.tabs
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
                this.fetchInitialEOD();
            } else {
                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);
                this.fetchInitialEOD();
            }
        }
    },

    methods: {
        fetchInitialEOD() {
            this.$store.dispatch("order/fetchSalesReturn", {
                perPage: this.perPage,
                currentPage: this.currentPage,
                start_date: this.start_date,
                end_date: this.end_date,
                search_term: this.filter,
                status: this.status,
                client: this.client,
                project: this.project,
                employee: this.selectedEmployee
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        toggleFilterShow() {
            this.filterShow = !this.filterShow
        },

        getStatusClass(status) {
            switch (status) {
                case 'approved':
                    return 'bg-success';
                case 'pending':
                    return 'bg-warning text-dark';
                case 'rejected':
                    return 'bg-danger';
                default:
                    return 'bg-secondary';
            }
        },

        clearFilter() {
            this.filterShow = false,
            this.filter = null,
            this.start_date = null,
            this.end_date = null,
            this.status = '',
            this.client = '',
            this.project = '',
            this.selectedDepartment = '',
            this.selectedDesignation = '',
            this.selectedEmployee = ''
        },

        getStatus(status, id) {
            this.update_id = id
            this.selectedStatus = status
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        handleStatusOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleStatusSubmit()
        },

        handleStatusSubmit() {
            this.$store.dispatch("order/updateSalesReturnStatus", {
                id: this.update_id,
                status_for_change: this.selectedStatus,
                page: this.$route.query.page,
                perPage: this.$route.query.perPage 
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-status')
            })
        }
    }
};
</script>
